!(function (e) {
	e.fn.publicReviews = function (r) {
		var a = e(this),
			s = a.attr("href"),
			n = "",
			p = {
				origin: "widget",
				page: 1,
				per_page: 5,
				random: !1,
			},
			t = {
				wrapper: null,
				"message-error-class": "error-message",
				"wrapper-error-class": "error-wrapper",
				"loading-class": "loading",
			},
			i = function () {
				a.hide(), o(), c(), l(), d(), u(), g();
			},
			o = function () {
				(r = r || {}), (t = e.extend(t, r));
			},
			c = function () {
				wrapper = e(t.wrapper).length ? e("#" + t.wrapper) : a.closest("div");
			},
			l = function () {
				wrapper.addClass("loading");
			},
			d = function () {
				t.origin && (p.origin = t.origin), t.per_page && (p.per_page = t.per_page), t.page && (p.page = t.page), t.random && (p.random = t.random);
			},
			u = function () {
				wrapper.bind("ajaxError, error", function () {
					wrapper.addClass(t["wrapper-error-class"]).append('<p class="' + t["message-error-class"] + '">There was a problem getting public reviews.</p>');
				});
			},
			g = function () {
				e.ajax({
					type: "GET",
					url: s + ".js",
					dataType: "jsonp",
					data: p,
					contentType: "application/javascript",
					error: function () {
						wrapper.addClass(t["wrapper-error-class"]).append('<p class="' + t["message-error-class"] + '">There was a problem getting public reviews.</p>');
						// Hides Reviews Section if no reviews or error.
						$("#reviews-section").hide();
						$("#reviews-link")[0].style.setProperty("display", "none", "important");
					},
					success: function (index) {
						wrapper.removeClass(t["loading-class"]);

						if (" " == index.responseText) {
							wrapper.error();
						} else {
							a.show();

							 const itemCount = index.length;
							// " " == index.responseText ? wrapper.error() : (a.show(),
							e.each(index, function (index, s) {
								if (s.recommendation_likelihood >= 8) {
									const p = m(s.completed_at);
									const rating = s.recommendation_likelihood;
									const { fullStars, halfStars, noStars } = calculateStars(rating);
									const stars = generateStars(fullStars, halfStars, noStars);
									indexPlus = index + 1;

									const reviewHtml = `
												<div
													class="slideshow__slide ${index === 0 ? "is-active" : ""} w-full pb-0"
													role="group"
													aria-roledescription="Slide"
													aria-label="${indexPlus} of ${itemCount}"
													${index !== 0 ? 'tabindex="-1" aria-hidden="false"' : ""}
													data-index="${index}"
														>
													<figure class="testimonial m-0 has-motion">
															<blockquote class="testimonial__quote text-h3 rte text-center m-0">
															${s.comments}
															</blockquote>

																<div class="testimonial-stars text-center mt-6 md:mt-8">
																	<div class="rating inline-block align-middle" role="img" aria-label="5 out of 5">
																		<span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;">${stars}</span>
																	</div>
																</div>

																<div class="testimonial__author flex items-center justify-center mt-12 md:mt-14">
																	<div class="testimonial__author-text text-center">
																		<p class="font-bold mb-0">${s.public_reviewer_name}</p>
																	</div>
																</div>
													</figure>
												</div>
												`;
									const dotsHtml = `
												<button class="page-btn" data-index="${index}" aria-controls="location-360-reviews" aria-current="${index === 0 ? "true" : "false"}">
													<span class="visually-hidden">Load slide ${indexPlus} of ${itemCount}</span>
													<span class="page-btn__line block relative overflow-hidden pointer-events-none"></span>
												</button>
												`;

									// <span>${p}</span>
									const reviewElement = e(reviewHtml);
									a.append(reviewElement);

									// Append parsed dotsHtml to the "slideshow-pagination" container
									const slideshowPagination = document.querySelector(".slideshow-pagination");
									if (slideshowPagination) {
										slideshowPagination.insertAdjacentHTML("beforeend", dotsHtml);
									}
								}

								function calculateStars(rating) {
									const fullStars = Math.floor(rating / 2);
									const halfStars = rating % 2 === 1 ? 1 : 0;
									const noStars = 5 - fullStars - halfStars;
									return { fullStars, halfStars, noStars };
								}

								function generateStars(fullStars, halfStars, noStars) {
									let starsHtml = "";
									for (let ix = 1; ix <= fullStars; ix++) {
										starsHtml += "&#9733;";
									}
									if (halfStars === 1) {
										starsHtml += '<span class="starHalf">&#9733;</span>';
									}
									for (let ix = 0; ix < noStars; ix++) {
										starsHtml += "&#9734;";
									}
									return starsHtml;
								}
							});
						}

						slideShow();
						// $("#reviews-link").appendTo(".hide-link");
					},
				});
			},
			m = function (e) {
				return (formatted = new Date(e)), (months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]), months[formatted.getMonth()] + " " + formatted.getDate() + ", " + formatted.getFullYear();
			};
		i();
	};
})(jQuery);